import React from 'react';
import { CheckIcon } from './Icons';
import { COMPRESS_IMAGE } from '../Common/Constants/ComponentType';

const CompressionOptions = ({ compressionLevel, setCompressionLevel }) => {
    return <div className="options-list" style={{ marginBottom: "20px" }}>
        <div className={`option-item ${compressionLevel === 10 ? 'active' : ''}`} onClick={() => setCompressionLevel(10)}>
            <div>
                <span className="option-title">EXTREME COMPRESSION</span>
                <span className="option-subtitle">Less quality, high compression</span>
            </div>
            {compressionLevel === 'extreme' && <CheckIcon />}
        </div>
        <div className={`option-item ${compressionLevel === 40 ? 'active' : ''}`} onClick={() => setCompressionLevel(40)}>
            <div>
                <span className="option-title">RECOMMENDED COMPRESSION</span>
                <span className="option-subtitle">Good quality, good compression</span>
            </div>
            {compressionLevel === 'recommended' && <CheckIcon />}
        </div>
        <div className={`option-item ${compressionLevel === 70 ? 'active' : ''}`} onClick={() => setCompressionLevel(70)}>
            <div>
                <span className="option-title">LESS COMPRESSION</span>
                <span className="option-subtitle">High quality, less compression</span>
            </div>
            {compressionLevel === 'less' && <CheckIcon />}
        </div>
    </div>
}

const DefaultComponent = ({ error, compressionLevel, setCompressionLevel, setIsOptionsVisible }) => {
    return (<div className="options-card-itp">
        <button className="close-options-btn-itp" onClick={() => setIsOptionsVisible(false)}>×</button>
        <h3>Compression Levels</h3>
        <div className={error ? "alert alert-danger" : "d-none"} role="alert">
            {error}
        </div>
        <CompressionOptions
            compressionLevel={compressionLevel}
            setCompressionLevel={setCompressionLevel}
        />

    </div>)
}

const renderComponent = (
    handleDownload,
    isGenerating,
    componentType,
    error,
    setCompressionLevel,
    compressionLevel,
    setIsOptionsVisible,
    processingText
) => {
    switch (componentType) {
        case COMPRESS_IMAGE:
            return <DefaultComponent
                handleDownload={handleDownload}
                isGenerating={isGenerating}
                compressionLevel={compressionLevel}
                setCompressionLevel={setCompressionLevel}
                error={error}
                setIsOptionsVisible={setIsOptionsVisible}
                processingText={processingText}
            />
        default:
            return <></>

    }
}

const RightPane = ({
    handleDownload,
    isGenerating,
    componentType,
    error,
    setCompressionLevel,
    compressionLevel,
    processingText,
    isOptionsVisible,
    setIsOptionsVisible
}) => {
    return (<><div className={`right-pane-itp ${isOptionsVisible ? 'visible' : ''}`}>
        {
            renderComponent
                (
                    handleDownload,
                    isGenerating,
                    componentType,
                    error,
                    setCompressionLevel,
                    compressionLevel,
                    setIsOptionsVisible,
                    processingText,                    
                )
        }
        <button
            onClick={handleDownload}
            disabled={isGenerating}
            className="theme-btn-blue"
            style={{ marginTop: '20px' }}
        >
            {isGenerating ? `${processingText}...` : processingText}
        </button>
    </div>
        <button className="mob-theme-btn-blue" onClick={handleDownload} disabled={isGenerating}>
            {isGenerating ? `${processingText}...` : processingText}
        </button>
    </>);
}

export default RightPane;